import {z} from 'zod';
import {SchemaValidationErrorLabel} from '@netx/core-schema';

export enum UserIntegrationType {
	API = 'API',
	HOOTSUITE = 'Hootsuite',
	CIHUB = 'CIHUB',
	LINKRUI = 'LINKRUI',
	ZAPIER = 'ZAPIER',
}

export const UserIntegrationActionSummary = {
	[UserIntegrationType.API]: 'API Access',
	[UserIntegrationType.HOOTSUITE]: 'Search, browse, and download assets',
	[UserIntegrationType.CIHUB]:
		'Search, browse, upload, download, and update assets',
	[UserIntegrationType.LINKRUI]:
		'Search, browse, upload, download, and update assets',
	[UserIntegrationType.ZAPIER]:
		'Search, browse, upload, download, and update assets',
};

export const UserIntegrationSchema = z.object({
	actionSummaries: z.array(z.string()),
	appId: z.number(),
	creationDate: z.date(),
	enabled: z.boolean(),
	modDate: z.date(),
	name: z.string().nonempty(SchemaValidationErrorLabel.REQUIRED),
	type: z.nativeEnum(UserIntegrationType),
});

export default UserIntegrationSchema;

export const UserIntegrationField = UserIntegrationSchema.keyof().enum;

export type IUserIntegration = z.infer<typeof UserIntegrationSchema>;

export const UserIntegrationSchemaNew = UserIntegrationSchema.pick({
	name: true,
});

/** a new user integration record */
export type IUserIntegrationNew = z.infer<typeof UserIntegrationSchemaNew>;

export const UserIntegrationFormSchema = UserIntegrationSchema.pick({
	name: true,
});

/** integration form values schema */
export type IUserIntegrationFormValues = z.infer<
	typeof UserIntegrationFormSchema
>;

export const UserIntegrationDetails = UserIntegrationSchema.pick({
	actionSummaries: true,
	name: true,
});

export type IUserIntegrationDetails = z.infer<typeof UserIntegrationDetails>;

export type AuthorizeIntegrationParams = {
	client_id: string | null;
	redirect_uri: string | null;
	response_type: string | null;
	scope: Lowercase<UserIntegrationType> | null;
	state: string | null;
};
